module.exports = __webpack_public_path__ + "media/img/Landing_Page/scholarship-01-c891d7ff7198d79ff2195c279c6acd9e.jpg";